import { Trans } from "@lingui/react/macro"
import type { IProps } from "./interfaces"

import classes from "./styles.module.css"

/**
 * Recording-mode chip. Full is the default, so the chip only appears for a
 * Lite recording — and it says "Lite", not a status word.
 */
export const RecordingModeChip = ({ mode }: IProps): React.JSX.Element | null => {
  if (mode !== "lite") return null

  return (
    <span className={classes.chip} data-mode={mode} data-testid="recording-mode-chip">
      <Trans>Lite</Trans>
    </span>
  )
}
